import React from "react";
import Imgix, { buildURL } from "react-imgix";
import { useIntl } from 'react-intl';
import "lazysizes";

import partners from "@constants/partners";
import styles from "./partnersList.module.scss";
import { renderWithBreaks } from '@utils/translations';

const PartnersList = () => {
  const intl = useIntl();

  return (
    <div className={styles.partnersList}>
      {
        partners.map(partnerData => {
          if (!partnerData) {
            return null;
          }

          const { name, link, slug } = partnerData;

          const photo = {
            url: `${process.env.CDN_URL}/images/partners/${slug}.png`,
            alt: `${name} Image`
          };

          return (
            <div className={styles.partnersList__item} key={name}>
              <div className={styles.partnersList__logo}>
                <a
                  href={link}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Imgix
                    className='lazyload'
                    src={photo.url}
                    alt={photo.alt ? photo.alt : name}
                    width={250}
                    imgixParams={{ auto: 'compress,format' }}
                    attributeConfig={{
                      src: 'data-src',
                      srcSet: 'data-srcset',
                      sizes: 'data-sizes',
                    }}
                    htmlAttributes={{
                      src: buildURL(photo.url, {
                        auto: 'compress,format',
                        blur: 100,
                        w: 250,
                      }),
                    }}
                  />
                </a>
              </div>
              <div className={styles.partnersList__description}>
                {renderWithBreaks(intl.formatMessage({ id: `${name} description`}))}
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

export default PartnersList;
